<script setup lang="ts">
import { cn } from '@/lib/utils'

defineProps<{
  modelValue?: string | number
  type?: string
  error?: boolean
}>()
defineEmits<{ 'update:modelValue': [value: string] }>()
</script>

<template>
  <input
    :type="type ?? 'text'"
    :value="modelValue"
    :aria-invalid="error ? 'true' : undefined"
    :class="cn(
      'flex h-11 w-full rounded-lg border-0 bg-input px-3.5 text-sm text-foreground transition-shadow',
      'file:border-0 file:bg-transparent file:text-sm file:font-medium',
      'placeholder:text-subtle focus-visible:outline-none focus-visible:ring-2',
      'disabled:cursor-not-allowed disabled:opacity-50',
      error ? 'ring-2 ring-destructive' : 'focus-visible:ring-ring',
    )"
    @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
  >
</template>
